import { Controller } from 'stimulus';

export default class extends Controller {
  connect() {
    if (!this.element.classList.contains('is-not-closed-dropdown')) {
      this.closeDropdownsListener = document.addEventListener('click', () => this.closeAll())
    }
  }

  disconnect() {
    document.removeEventListener('click', this.closeDropdownsListener);
  }

  open(event) {
    event.preventDefault();
    event.stopPropagation();

    this.closeAll(this.element);

    this.element.classList.toggle('is-active');
  }

  closeAll(except) {
    document.querySelectorAll('.dropdown:not(.is-hoverable)').forEach((element) => {
      if (element != except) {
        element.classList.remove('is-active');
      }
    })
  }
}
